/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import { List, Map as ImmutableMap, Record, Set as ImmutableSet, is } from 'immutable';
import PropTypes from 'prop-types';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { memo } from 'react';
import { getType } from '../../../common-message-format/operators/commonMessageFormatGetters';
import PositionDescriptors from '../../../proptypes/PositionDescriptors';
import SenderMap from '../../../proptypes/SenderMap';
import { LegacyRecipientMapPropType } from '../../../proptypes/RecipientMap';
import AsyncFileAttachmentsMap from '../../../proptypes/AsyncFileAttachmentsMap';
import { MESSAGE_ID_ATTR } from '../../../web/message-history/constants/constants';
import { getMessageId } from '../../../message-history/operators/getMessageId';
import { jsx as _jsx } from "react/jsx-runtime";
const shouldRerender = (prev, next) => {
  return !Object.keys(prev).some(key => {
    if (key === 'fileAttachments' || key === 'positionDescriptors' || key === 'senders') {
      return !is(prev[key], next[key]);
    }
    return prev[key] !== next[key];
  });
};
const MessageHistoryItem = /*#__PURE__*/memo(({
  allowContactPromotions,
  fileAttachments,
  fileAttachmentsForThread,
  friendlyNames,
  indexedAsyncFileAttachments,
  hiddenBy,
  historyConfig,
  message,
  portalId,
  positionDescriptors,
  presentSenderLocators,
  senders,
  legacyRecipients,
  visitorLastReadTimestamp,
  lastMessageId,
  vid,
  recipientVisitors,
  threadHistory,
  threadId,
  ungatedForNextBestActions,
  ungatedForReplyToAllMessages,
  channelName,
  slots
}) => {
  const idAttr = {
    [MESSAGE_ID_ATTR]: getMessageId(message)
  };
  const Component = historyConfig[getType(message)];
  return Component ? /*#__PURE__*/_jsx("div", Object.assign({}, idAttr, {
    children: /*#__PURE__*/_jsx(Component, {
      allowContactPromotions: allowContactPromotions,
      channelName: channelName,
      fileAttachments: fileAttachments,
      fileAttachmentsForThread: fileAttachmentsForThread,
      friendlyNames: friendlyNames,
      hiddenBy: hiddenBy,
      indexedAsyncFileAttachments: indexedAsyncFileAttachments,
      message: message,
      portalId: portalId,
      positionDescriptors: positionDescriptors,
      senders: senders,
      legacyRecipients: legacyRecipients,
      presentSenderLocators: presentSenderLocators,
      visitorLastReadTimestamp: visitorLastReadTimestamp,
      lastMessageId: lastMessageId,
      vid: vid,
      recipientVisitors: recipientVisitors,
      threadHistory: threadHistory,
      threadId: threadId,
      ungatedForNextBestActions: ungatedForNextBestActions,
      ungatedForReplyToAllMessages: ungatedForReplyToAllMessages,
      slots: slots
    })
  })) : null;
}, shouldRerender);
MessageHistoryItem.displayName = 'MessageHistoryItem';
MessageHistoryItem.propTypes = {
  allowContactPromotions: PropTypes.bool,
  channelName: PropTypes.string,
  fileAttachments: PropTypes.instanceOf(List),
  fileAttachmentsForThread: PropTypes.instanceOf(ImmutableMap),
  hiddenBy: PropTypes.shape({
    actorId: PropTypes.string.isRequired,
    timestamp: PropTypes.number.isRequired
  }),
  historyConfig: PropTypes.object.isRequired,
  indexedAsyncFileAttachments: AsyncFileAttachmentsMap,
  lastMessageId: PropTypes.string,
  legacyRecipients: LegacyRecipientMapPropType,
  message: PropTypes.instanceOf(Record).isRequired,
  portalId: PropTypes.number,
  positionDescriptors: PositionDescriptors.isRequired,
  presentSenderLocators: PropTypes.instanceOf(ImmutableSet),
  recipientVisitors: PropTypes.instanceOf(ImmutableMap),
  senders: SenderMap,
  slots: PropTypes.object,
  threadHistory: RecordPropType('ThreadHistory'),
  threadId: PropTypes.string,
  ungatedForNextBestActions: PropTypes.bool,
  ungatedForReplyToAllMessages: PropTypes.bool,
  vid: PropTypes.number,
  visitorLastReadTimestamp: PropTypes.number
};
MessageHistoryItem.defaultProps = {
  innerRef: () => {},
  positionDescriptors: []
};
export default MessageHistoryItem;